module.exports = "<ul class=\"ns-list ns-list-1-col\">\r\n  <li *ngFor=\"let item of intramural\">{{item}}</li>\r\n</ul>\r\n"